import i18n from 'core/common/i18n/index'
import { isArray } from 'core/common/utils/is'

const extractValues = message => {
  const values = message.match(/\b\d+\b/g)
  if (values && values.length === 2) {
    return values.map(Number)
  }

  return ['', '']
}
const getMessageAndFildsError = (err, index) =>
  Object.keys(err).map(item => {
    const a = Object.entries(err[item])
    return a.map(i => i[index])
  })

const translateError = detail => {
  try {
    if (isArray(detail)) {
      return detail?.map(item => {
        if (item.toLowerCase().includes('maximum length')) {
          const num = item.replace(/^\D+/g, '')
          return i18n.t('product.validations.maxValue', { count: num })
        }
        if (item.toLowerCase().includes('length must be between')) {
          const [min_value, max_value] = extractValues(item)
          return i18n.t('product.validations.minMaxValue', { min_value, max_value })
        }
        return item
      })
    }
  } catch {
    return detail
  }
}

export { getMessageAndFildsError, translateError }
